// إيصال الاشتراك الشهري — بنفس تصميم إيصالات النظام (الاستقبال/الخروج):
// عرض 280px على الشاشة، وطباعة 80مم عبر `.receipt-print-area` و`printReceipt()`
// المشتركَين، فلا يوجد تنسيق طباعة ثانٍ يتفرّع عن الأول.
//
// كل أرقامه تأتي من استجابة الخادم المشتقّة من فاتورة المبيعات المسجَّلة لحظة
// القبض — لا يُحسب هنا مبلغ ولا يُولَّد رقم إيصال، فالطباعة وإعادة الطباعة
// تعرضان نفس الشيء بالضبط ولا تُنشئان عملية ثانية.
import { formatIQD, formatDate, formatDateTime } from '../../../shared/format.js';
import { ReceiptBrand } from '../../../shared/ReceiptBrand.jsx';

const METHOD_LABEL = {
  cash: 'نقدي',
  card: 'بطاقة',
  transfer: 'تحويل',
  external: 'خارجي',
  card_balance: 'رصيد الكارت'
};

export function SubscriptionReceipt({ data }) {
  if (!data) return null;
  const isRenewal = data.type === 'renewal';

  return (
    <div
      className="receipt-print-area mx-auto bg-white text-ink p-4"
      style={{
        width: 280,
        fontFamily: '"Tajawal", monospace',
        fontSize: 12,
        boxShadow: '0 4px 14px rgba(0,0,0,.08)',
        borderRadius: 8
      }}
    >
      <ReceiptBrand subtitle={isRenewal ? 'إيصال تجديد اشتراك شهري' : 'إيصال اشتراك شهري'} />
      <hr className="border-dashed my-1" />

      <Row label="رقم الإيصال" value={data.receiptNumber || '—'} dir="ltr" mono />
      <Row label="التاريخ والوقت" value={formatDateTime(data.at)} dir="ltr" />
      <Row label="الموظف المنفّذ" value={data.cashierName || '—'} />
      <hr className="border-dashed my-1" />

      <Row label="الطفل" value={data.childName || '—'} />
      {data.guardianName ? <Row label="ولي الأمر" value={data.guardianName} /> : null}
      {data.guardianPhone ? <Row label="الهاتف" value={data.guardianPhone} dir="ltr" mono /> : null}
      {data.cardUid ? <Row label="رقم البطاقة" value={data.cardUid} dir="ltr" mono /> : null}
      <hr className="border-dashed my-1" />

      <Row label="الباقة" value={data.planName || '—'} />
      <Row label="تاريخ البداية" value={formatDate(data.startDate)} dir="ltr" />
      <Row label="تاريخ الانتهاء" value={formatDate(data.endDate)} dir="ltr" />
      <hr className="border-dashed my-1" />

      <Row label="قيمة الاشتراك" value={formatIQD(data.price || 0)} />
      <Row label="المبلغ المدفوع فعلاً" value={formatIQD(data.paidAmount || 0)} bold />
      {Number(data.cardTopupAmount || 0) > 0 ? (
        <>
          <Row label="تعبئة رصيد البطاقة" value={formatIQD(data.cardTopupAmount)} />
          <Row label="إجمالي المستلم" value={formatIQD(data.totalReceived || 0)} bold />
        </>
      ) : null}
      <Row label="طريقة الدفع" value={METHOD_LABEL[data.paymentMethod] || data.paymentMethod || '—'} />

      <hr className="border-dashed my-1" />
      {data.reprint ? (
        <div className="text-center text-[10px]">— نسخة معادة الطباعة —</div>
      ) : null}
      <div className="text-center text-[10px] mt-2">شكراً لزيارتكم</div>
    </div>
  );
}

function Row({ label, value, dir, mono, bold }) {
  return (
    <div className="flex justify-between" style={{ padding: '1px 0' }}>
      <span>{label}:</span>
      <span dir={dir} style={{ fontFamily: mono ? 'monospace' : undefined, fontWeight: bold ? 800 : 600 }}>
        {value}
      </span>
    </div>
  );
}
